import React from 'react';
import styled from 'styled-components';
import {isMobile} from "react-device-detect";
import SVG from 'react-inlinesvg';
import {IWalletCardProps} from '../types';
import {connectorLocalStorageKey} from '../../../config/constants/wallets';

const Block = styled.div`
  display: grid;
  padding: 8px;
  border-radius: ${({theme}) => theme.borderRadius};
  grid-auto-flow: column;
  grid-template-columns: auto 1fr;
  cursor: pointer;
  height: 56px;
  align-items: center;
  column-gap: ${({theme}) => theme.space[1]};
  background: linear-gradient(130.22deg, #9199FF 26.49%, #3C95DB 100.77%);

  :hover {
    background: linear-gradient(130.22deg, #acb2fd 26.49%, #66ace3 100.77%);
  }
`;

const Name = styled.div`
  color: #fff;
  font-size: 18px;
  font-weight: 400;
`;

const WalletCard: React.FC<IWalletCardProps> = (props) => {

    const {title, icon, connectorId, closeModal, login, deepLink, installed} = props;

    return (
        <Block
            onClick={() => {
                login(connectorId);
                if (title === "Metamask" && isMobile && deepLink && installed === false) {
                    window.open(deepLink);
                }
                window.localStorage.setItem(connectorLocalStorageKey, connectorId);
                closeModal();
            }}
        >
            <SVG src={icon}/>
            <Name>{title}</Name>
        </Block>
    );
};

export default WalletCard;
